<template>
    <div>
        <!-- 轮播图 -->
        <div class="bg">
            <div class="sub-title">Milestone</div>
            <!-- <div class="title">发展历程</div> -->
        </div>
        <div class="p-3">
            <el-timeline>
                <el-timeline-item placement="top" v-for="(item, index) in milestoneList" :key="index">
                    <div class="flex-row justify-around">
                        <div>
                            <div class="sub-time">{{ item.occuDate }}</div>
                        </div>
                        <div style="width: 200px;">
                            <div>{{ item.ettribute1 }}</div>
                            <!-- <p>{{item.title}}</p> -->
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
        </div>
    </div>
</template>
  
<script type="text/babel">
export default {
    name: "HomePage",
    data() {
        return {

            milestoneList:[
                // {
                //     id: '001',
                //     introduce: 'Leading the drafting of the first industry standard The third generation controller products launched',
                //     year: '2022'
                // },{
                //     id: '002',
                //     introduce: 'Expanded the application of aerial work platforms',
                //     year: '2021'
                // },{
                //     id: '003',
                //     introduce: 'The product was used in sweepers Implemented large-scale industry customization',
                //     year: '2020'
                // },{
                //     id: '004',
                //     introduce: 'The second generation D1 series controller and M1 series smart display won the industry innovation gold award',
                //     year: '2019'
                // },{
                //     id: '005',
                //     introduce: 'Expanded to golf cart applications',
                //     year: '2018'
                // },{
                //     id: '006',
                //     introduce: 'The company was awarded the Suzhou Gusu Entrepreneurial Angel Project',
                //     year: '2017'
                // },{
                //     id: '007',
                //     introduce: 'FJ controlling (Suzhou) Co., Ltd. was established production capacity 200,000 units per year',
                //     year: '2016'
                // },{
                //     id: '008',
                //     introduce: 'The product won 2 industry innovation awards',
                //     year: '2015'
                // }
                // ,{
                //     id: '009',
                //     introduce: 'The first generation V2 series launched mainly used for electric forklifts',
                //     year: '2014'
                // },{
                //     id: '010',
                //     introduce: 'Beijing Fanji Technology Co., Ltd. was established',
                //     year: '2012'
                // },{
                //     id: '011',
                //     introduce: 'Start the R&D work of the AC motor controller for electric forklifts',
                //     year: '2011'
                // }
            ]
        };
    },
    methods: {

    },
    mounted() {
        /* banner-swiper */
        debugger
            let that=this;
            this.http.post("/api/FJ_Milestone/GetAllMilestone",JSON.stringify({})).then((result)=>{
                debugger
            let objResult= eval(result);
            let iCode= objResult.code;
            if(iCode==0){
                debugger
                that.milestoneList=objResult.data;
                }
            });

    }
};
</script>
  
<style scoped lang="scss">
.bg {
    background: url('../../assets/img/milestonebanner.jpg') no-repeat;
    background-size: 100% ;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}
.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.p-3 {
    padding: 15px;
}

.sub-time {
    display: flex;
    background-color: #0AA00A;
    color: #fff;
    padding: 4px;
    border-radius: 5px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/milestone/m_index.vue